//data of areas

type Area = {
  id: number;
  name: string;
  status: string;
  critical: number;
  criticalValue: number;
  location: string;
  size: number;
  lat: number;
  long: number;
};

export const cityData: Area[] = [
  {
    id: 1,
    name: "Kansai Airport",
    status: "Observe",
    critical: 12,
    criticalValue: -3,
    location: "Japan",
    size: 38.34,
    lat: 34.432,
    long: 135.2304,
  },
  {
    id: 2,
    name: "Miyazaki",
    status: "Safe",
    critical: 2,
    criticalValue: 0,
    location: "Japan",
    size: 28.34,
    lat: 31.9077,
    long: 131.4202,
  },
  {
    id: 3,
    name: "Tokyo",
    status: "Safe",
    critical: 5,
    criticalValue: +1,
    location: "Japan",
    size: 58.34,
    lat: 35.6762,
    long: 139.6503,
  },
  {
    id: 4,
    name: "Changi airport",
    status: "Critical",
    critical: 44,
    criticalValue: -12,
    location: "Japan",
    size: 138.34,
    lat: 1.3644,
    long: 103.9915,
  },
  {
    id: 5,
    name: "Incheon",
    status: "Safe",
    critical: 12,
    criticalValue: -1,
    location: "Japan",
    size: 8.34,
    lat: 37.4563,
    long: 126.7052,
  },
  {
    id: 6,
    name: "Nagano",
    status: "Safe",
    critical: 23,
    criticalValue: -2,
    location: "Japan",
    size: 0.34,
    lat: 36.6485,
    long: 138.195,
  },
  {
    id: 7,
    name: "Mie 1",
    status: "Critical",
    critical: 356,
    criticalValue: -65,
    location: "Japan",
    size: 38,
    lat: 33.8144,
    long: 136.0487,
  },
  {
    id: 8,
    name: "Mie 2",
    status: "Observe",
    critical: 52,
    criticalValue: +2,
    location: "Japan",
    size: 38.34,
    lat: 33.8144,
    long: 136.0487,
  },
  {
    id: 9,
    name: "Ikebokuro Station",
    status: "Observe",
    critical: 57,
    criticalValue: 0,
    location: "Japan",
    size: 4.2,
    lat: 35.7295,
    long: 139.7109,
  },
  {
    id: 10,
    name: "Akihabara",
    status: "Safe",
    critical: 7,
    criticalValue: -1,
    location: "Japan",
    size: 6.9,
    lat: 35.7023,
    long: 139.7745,
  },
  {
    id: 11,
    name: "Kumamoto",
    status: "Safe",
    critical: 11,
    criticalValue: +4,
    location: "Japan",
    size: 358.34,
    lat: 32.8032,
    long: 130.7079,
  },
  {
    id: 12,
    name: "Roppongi",
    status: "Observe",
    critical: 100,
    criticalValue: -4,
    location: "Japan",
    size: 318.34,
    lat: 35.6619,
    long: 139.7345,
  },
];
